import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet } from "react-native";
import Queries from "../../api/queries";
import { ActivityIndicator } from "react-native-paper";

const Monthly = ({date}) => {
    const queries = new Queries();
    const [summaryItems, setSummaryItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const fetchSummaryItems = (date) => {
        queries.getMonthlyData(date)
            .then(response => {
                setSummaryItems(response?.data?.OA_getMonthlyData);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (date) {
            fetchSummaryItems(date);
        }
    }, [date]);

    if (loading) return <ActivityIndicator />;
    if (error) return <Text>Error: {error.message}</Text>;

    

    return (
        <>
            <Text style={styles.heading}>Compte Rendu</Text>
            <View style={styles.summary}>
                {summaryItems?.map((item, index) => (
                    <View key={index} style={styles.summaryItem}>
                        <Text style={styles.summaryLabel}>{item.label}</Text>
                        <Text style={styles.summaryValue}>{item.value}</Text>
                    </View>
                ))}
            </View>
        </>
    )
}

const styles = StyleSheet.create({
    heading: {
        fontSize: 20,
        fontWeight: 'bold',
    },
    summary: {
        padding: 15,
        borderRadius: 8,
        gap: 10,
    },
    summaryItem: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    summaryLabel: {
        fontSize: 16,
        fontWeight: 'bold',
    },
    summaryValue: {
        fontSize: 16,
    },
});

export default Monthly;